import { render, staticRenderFns } from "./trafficShiji.vue?vue&type=template&id=93f81738&scoped=true&"
import script from "./trafficShiji.vue?vue&type=script&lang=js&"
export * from "./trafficShiji.vue?vue&type=script&lang=js&"
import style0 from "./trafficShiji.vue?vue&type=style&index=0&id=93f81738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f81738",
  null
  
)

export default component.exports